<div class="main-container">
  <div class="d-flex justify-content-between align-items-center" style="border-radius: 10px; font-size: 16px; background-color: #fff;">
    <ion-title  class="dark-title-sm ion-padding-horizontal ">Search Flight</ion-title>
    <ion-button (click)="closeModal()" class="unfilled-gray-btn">
      <ion-icon name="close-outline"></ion-icon>
    </ion-button>
  </div>
  <div class="inner-container pt-2">

    <form [formGroup]="searchForm">
      <div class="search-grid">
        <div class="input-container">
          <label for="" class="label">Trip Type*</label>
          <div
            [ngClass]="{ 'invalid-input': searchForm.get('tripType')?.invalid && searchForm.get('tripType')?.touched }">
            <select class="input" formControlName="tripType">
              <option *ngFor="let item of tripTypes" [value]="item.id">
                {{item.name}}
              </option>
            </select>
          </div>

        </div>
        <div class="input-container">
          <label for="" class="label">Departure Airport*</label>
          <div
            [ngClass]="{ 'invalid-input': searchForm.get('departureAirport')?.invalid && searchForm.get('departureAirport')?.touched }">
            <!-- <input class="input" type="text" placeholder="Departure Airport" formControlName="departureAirport"> -->
            <app-airport-search-input formControlName="departureAirport"></app-airport-search-input>
          </div>
        </div>
        <div class="input-container">
          <label for="" class="label">Arrival Airport*</label>
          <div
            [ngClass]="{ 'invalid-input': searchForm.get('arrivalAirport')?.invalid && searchForm.get('arrivalAirport')?.touched }">
            <!-- <input class="input" type="text" placeholder="Arrival Airport" formControlName="arrivalAirport"> -->
            <app-airport-search-input formControlName="arrivalAirport"></app-airport-search-input>
          </div>
        </div>
        <div class="input-container">
          <!-- Dummy for grid -->
        </div>
        <div class="input-container">
          <label for="" class="label">Select Class*</label>
          <div
            [ngClass]="{ 'invalid-input': searchForm.get('class')?.invalid && searchForm.get('class')?.touched }">
            <select class="input" formControlName="class">
              <option *ngFor="let item of cabinClass" [value]="item.id">
                {{item.name}}
              </option>
            </select>
          </div>
        </div>
        <div class="input-container">
          <label for="" class="label">No Of Guests*</label>
          <div
            [ngClass]="{ 'invalid-input': searchForm.get('noOfGuests')?.invalid && searchForm.get('noOfGuests')?.touched }">
            <app-no-of-guests-input formControlName="noOfGuests"> </app-no-of-guests-input>
          </div>
        </div>
        <div class="input-container">
          <label for="" class="label">Departure Date*</label>
          <div
            [ngClass]="{ 'invalid-input': searchForm.get('departureDate')?.invalid && searchForm.get('departureDate')?.touched }">

            <app-date-picker [minDate]="today()" formControlName="departureDate">
            </app-date-picker>
          </div>
        </div>
        <div class="input-container" *ngIf="searchForm.get('tripType')?.value == 2">
          <label for="" class="label">Return Date*</label>
          <div [ngClass]="{ 'invalid-input': searchForm.get('arrivalDate')?.invalid && searchForm.get('arrivalDate')?.touched }">
            <app-date-picker [minDate]="searchForm.get('departureDate')?.value" formControlName="arrivalDate">
            </app-date-picker>
          </div>

        </div>
      </div>
      <div class="d-flex justify-content-end">
        <ion-button type="button" class="filled-blue-btn" (click)="searchFlights()">Search Flights</ion-button>
      </div>
    </form>

    <div class="d-flex gap-1">
      <ng-container *ngFor="let flights of allFlights; index as fIndex">
        <div class="flight-list">
          <div class="flight-card" *ngFor="let flight of flights">
            <div class="left">
              <div class="radio-btn-container">
                <input class="radio-input" type="radio" [name]="'flight'+fIndex" [checked]="selectedFlights[fIndex] === flight" (change)="onFlightSelect(flight, fIndex)" id="">
              </div>
              <div class="img-container">
                <img src="{{getAirlineLogo(flight)}}" alt="" class="image">
              </div>
              <div class="details-container">
                <h4 class="title">
                  {{flight.AirlineName}}
                </h4>
                <span class="sub-title">
                  {{flight.AirlineCode}}
                  {{flight.FlightNumber}}
                </span>
              </div>
            </div>
            <div class="middle">
              <div>
                <h3 class="date-label">
                  {{flight.DepTime | date:'HH:mm'}}
                </h3>
                <small>
                  {{flight.Origin.CityCode}}
                </small>
              </div>
              <div class="duration">
                {{getDuration(flight.Duration)}}
              </div>
              <div>
                <h3 class="date-label">
                  {{flight.ArrTime | date:'HH:mm'}}
                </h3>
                <small>
                  {{flight.Destination.CityCode}}
                </small>
              </div>
            </div>
            <div class="right">
              <div class="price">
                ₹{{flight.Fare.PublishedFare | number:'1.0-2'}}
              </div>
              <div class="cabin-class">
                {{flight.CabinClassName}}
              </div>
            </div>
          </div>

          <div class="no-flights-found" *ngIf="flights?.length == 0">
            <p class="msg">No Flights Found</p>
          </div>

        </div>
      </ng-container>
    </div>
    

    

  </div>
  <div class="footer-container" *ngIf="selectedFlights.length > 0">
    <div class="d-flex justify-content-center">
      <ion-button
        class="filled-blue-btn"
        (click)="addFlightsToTransportation()">
        Add {{ selectedFlights.length == 1 ? 'Flight' : 'Flights'}} To Transportation
      </ion-button>
    </div>
  </div>

</div>